import QuestionGroupConfig from './QuestionGroupConfig'

export { QuestionGroupConfig }
export default QuestionGroupConfig
